import { render, staticRenderFns } from "./option-group-form.vue?vue&type=template&id=676f2a2f&scoped=true&"
import script from "./option-group-form.ts?vue&type=script&lang=ts&"
export * from "./option-group-form.ts?vue&type=script&lang=ts&"
import style0 from "./option-group-form.scss?vue&type=style&index=0&id=676f2a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f2a2f",
  null
  
)

export default component.exports